import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import styles from "./numbers.module.css"

const formatter = new Intl.NumberFormat("pt-BR", {
  style: "decimal",
})

const percent = new Intl.NumberFormat("pt-BR", {
  style: "percent",
})

const currency = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
})

const Numbers = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            indicators {
              users
              totalLoan
              NPS
              companies
            }
          }
        }
      }
    `
  )

  return (
    <section className={styles.numbers}>
      <div className="wrapper">
        <h2>Nossos números</h2>

        <dl>
          <div className={styles.statistic}>
            <dt>{formatter.format(site.siteMetadata.indicators.users)} +</dt>
            <dd>Usuários atendidos</dd>
          </div>
          <div className={styles.statistic}>
            <dt>{currency.format(site.siteMetadata.indicators.totalLoan)} +</dt>
            <dd>Emergências financeiras resolvidas</dd>
          </div>
          <div className={styles.statistic}>
            <dt>{percent.format(site.siteMetadata.indicators.NPS)}</dt>
            <dd>NPS dos nossos clientes</dd>
          </div>
          <div className={styles.statistic}>
            <dt>{site.siteMetadata.indicators.companies} +</dt>
            <dd>Empresas atendidas</dd>
          </div>
        </dl>
      </div>
    </section>
  )
}

export default Numbers
